<template>
  <div class="notification">
    <div 
      :style="{ color: notification.color }"
      class="notification-title"
    >
      {{ notification.title }}
    </div>
    <div v-if="notification.error" class="notification-error">{{ notification.error }}</div>
    <div v-else class="notification-message">{{ notification.message }}</div>
    <md-progress-bar v-if="notification.loading" md-mode="indeterminate" />
    <div v-else class="action-bar">      
      <div
        v-for="(action, idx) in notification.actions" 
        :key="'action' + idx"
      >
        <md-button
          v-if="action.type === 'URL'"
          class="md-dense"
          :href="action.metadata.url"
          target="_blank"
          @click="trackNotificationClick()"
        >
          {{ action.label }}
        </md-button>
        <md-button
          v-if="action.type !== 'URL'"
          class="md-dense"
          @click="doAction(action)"
        >
          {{ action.label }}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notification',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async doAction(action) {
      this.$emit('doAction', action);
      if (action.type === 'DISMISS') {
        this.$analytics.event('Notifications', 'notification_dismiss', this.notification._id);
      } else {
        this.trackNotificationClick();
      }
    },
    trackNotificationClick() {
      this.$analytics.event('Notifications', 'notification_go_to', this.notification._id);
    }
  }
}
</script>

<style scoped>
.notification {
  width: 100%;
  background-color: #fff;
  padding: 6px 4px 4px 6px;
  display: flex;
  flex-direction: column;
}

.notification-title {
  line-height: 1.6em;
}

.notification:first-child {
  border-bottom: 1px solid lightgray;
}

.notification:not(:last-child) {
  padding-bottom: 0px;
}

.notification-message {
  padding-bottom: 6px 4px 0 4px;
}

.action-bar {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: flex-end;
}

.action-bar .md-button {
  margin: 0;
  width: 60px;
  min-width: 60px;
  text-transform: uppercase;
}

</style>